import { Component, computed, inject, Input, OnInit, Signal, input } from '@angular/core';
import { ImageCoordinates } from '../../../state-management/model/interfaces/screen-size.model';
import { WebsiteStateService } from '../../../state-management/services/website-state.service';
import { Result } from '../../../state-management/model/interfaces/state.model';
import { UtilityService } from '../../../services/utility.service';
import { logMethodCall } from '../../../decorators/log-method.decorator';

interface LabelConfig {
  [key: string]: string;
}

@Component({
    template: '',
    standalone: false
})
export abstract class BaseComponent implements OnInit {
  readonly elementIds = input<string[]>([]);
  @Input() labelMap: LabelConfig = {};
  @Input() imageReference!: ImageCoordinates;

  protected stateService = inject(WebsiteStateService);
  protected utils = inject(UtilityService);
  public signals: { [key: string]: Signal<string | undefined> } = {};

  ngOnInit(): void {
    for (const [key, label] of Object.entries(this.labelMap)) {
      this.signals[key] = this.stateService.getSingleElementIdByLabel(this.elementIds(), label);
    }
  }
  
  @logMethodCall()
  getSignal(key: string): Signal<Result<string, string>> {
    return computed(() => {
      const signalValue = this.signals[key]?.();
      return signalValue ? this.utils.ok(signalValue) : this.utils.fail('Signal not found', 404);
    });
  }
  
}